import { getStorage, ref, deleteObject } from 'firebase/storage';

export const deleteImagesFromFirebase = async (
  imagePaths: string[],
): Promise<void> => {
  const storage = getStorage();
  await Promise.all(imagePaths.map((path) => deleteObject(ref(storage, path))));
};
